var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictogrammeEdecVert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 161 159",
    style: {
      enableBackground: "new 0 0 161 159"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 79.5,
    x2: 161.0061,
    y2: 79.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F3BC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3BD482"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.9,58.5l-44.1-48C102.8,3.8,94.2,0,85.1,0h-53C23.6,0,15.6,3.3,9.5,9.3C3.4,15.3,0,23.2,0,31.5v96 c0,8.3,3.3,16.1,9.3,22c5.8,5.7,13.8,9.1,22.5,9.5l53.4,0c9,0,17.9-3.9,23.6-10.5l44.1-48l0.1-0.1C163.7,88.1,163.7,70.9,152.9,58.5 z M29.8,31.5c0-0.2,0.1-0.6,0.6-1c0.3-0.3,0.7-0.5,1.1-0.5h53c0.7,0,1.1,0.1,1.4,0.1l43.8,47.7c0.4,0.7,0.6,1.2,0.6,1.7 c0,0.2,0,0.3-0.1,0.4l-43.5,47.3c-1,0.6-1.9,1.1-2.3,1.1h-53c-0.8,0-1.7-0.8-1.7-1.5V31.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogrammeEdecVert);
export default __webpack_public_path__ + "static/media/Pictogramme_EDEC_vert.1f3d816b9b1a17790beec4746d490bdc.svg";
export { ForwardRef as ReactComponent };